import { Statistic } from 'antd';
import CountUp from 'react-countup';
import { CHANGE_TYPES, COLOR, PREFIX } from './StatisticsItem.constants';

export const StatisticsItem = ({ label, value, suffix = '', changeType = CHANGE_TYPES.SAME, className = '' }) => {
  const formatter = value => <CountUp end={value} separator='.' />;

  return (
    <Statistic
      className={className}
      title={label}
      value={value}
      formatter={formatter}
      suffix={suffix}
      prefix={PREFIX[changeType]}
      valueStyle={{ color: COLOR[changeType] }}
    />
  );
};
